import React, { useState, useEffect } from "react";
import { UseProductCluster } from "./UseProductCluster";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";

export default function ClusterAutoComplete(props) {
  const { getAllClusterList } = UseProductCluster();
  const [clusterRes, setClusterRes] = React.useState();
  const [selectedCluster, setSelectedCluster] = React.useState();

  useEffect(() => {
    getAllClusterList((clusters) => {
      setClusterRes(clusters);
    });
  }, []);

  useEffect(() => {
    if (!props.selectedClusterID) {
      setSelectedCluster();
    }
  }, [props.selectedClusterID]);

  useEffect(() => {
    if (clusterRes && props.selectedClusterID) {
      setSelectedCluster(
        clusterRes.items.find((m) => m.id == props.selectedClusterID)
      );
    }
  }, [clusterRes, props.selectedClusterID]);

  useEffect(() => {
    if (selectedCluster) {
      props.setter({
        ...props.lvl1State,
        clusterID: selectedCluster.id,
      });
    }
  }, [selectedCluster]);

  return clusterRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.width100 && "100%",
      }}
    >
      <Autocomplete
        disabled={props.disabled}
        id="combo-box-demo"
        value={selectedCluster ? selectedCluster : ""}
        options={clusterRes.items ? clusterRes.items : []}
        getOptionLabel={(clusters) => (clusters.title ? clusters.title : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            error={props.validation && props.validation}
            {...params}
            label="خوشه"
          />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.title ? option.title : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedCluster(newValue);
          } else {
            setSelectedCluster();
            props.setter({
              ...props.lvl1State,
              clusterID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllClusterList((clusters) => {
            setClusterRes(clusters);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/productcluster" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
